var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0622559 13.6558C0.0622559 6.11392 6.18033 0 13.7274 0H104.503C112.05 0 118.168 6.11392 118.168 13.6558V104.369C118.168 111.911 112.05 118.025 104.503 118.025H13.7274C6.18033 118.025 0.0622559 111.911 0.0622559 104.369V13.6558Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.503 0.975416H13.7274C6.7194 0.975416 1.03833 6.65262 1.03833 13.6558V104.369C1.03833 111.373 6.7194 117.05 13.7274 117.05H104.503C111.511 117.05 117.192 111.373 117.192 104.369V13.6558C117.192 6.65263 111.511 0.975416 104.503 0.975416ZM13.7274 0C6.18033 0 0.0622559 6.11392 0.0622559 13.6558V104.369C0.0622559 111.911 6.18033 118.025 13.7274 118.025H104.503C112.05 118.025 118.168 111.911 118.168 104.369V13.6558C118.168 6.11392 112.05 0 104.503 0H13.7274Z",
    fill: "#4A06D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44629 20.1528C6.44629 12.5462 12.6169 6.37975 20.2287 6.37975H98.0012C105.613 6.37975 111.784 12.5462 111.784 20.1528V97.8725C111.784 105.479 105.613 111.646 98.0012 111.646H20.2288C12.6169 111.646 6.44629 105.479 6.44629 97.8725V20.1528Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0012 7.36354H20.2287C13.1606 7.36354 7.43075 13.0895 7.43075 20.1528V97.8725C7.43075 104.936 13.1606 110.662 20.2288 110.662H98.0012C105.069 110.662 110.799 104.936 110.799 97.8725V20.1528C110.799 13.0895 105.069 7.36354 98.0012 7.36354ZM20.2287 6.37975C12.6169 6.37975 6.44629 12.5462 6.44629 20.1528V97.8725C6.44629 105.479 12.6169 111.646 20.2288 111.646H98.0012C105.613 111.646 111.784 105.479 111.784 97.8725V20.1528C111.784 12.5462 105.613 6.37975 98.0012 6.37975H20.2287Z",
    fill: "#4A06D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3511 130.382C71.3511 129.572 72.008 128.915 72.8184 128.915H116.838C123.591 128.915 129.065 123.445 129.065 116.696V72.7068C129.065 71.897 129.722 71.2405 130.533 71.2405C131.343 71.2405 132 71.897 132 72.7068V116.696C132 125.064 125.212 131.848 116.838 131.848H72.8184C72.008 131.848 71.3511 131.192 71.3511 130.382Z",
    fill: "#4A06D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.72d935b9ce6d20a583e4caad7f4c1019.svg";
export { ForwardRef as ReactComponent };